
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/ai-ux-sprint/done",
      function () {
        return require("private-next-pages/download/ai-ux-sprint/done/index.tsx");
      }
    ]);
  